import { ComponentRef, Injector } from '@angular/core';
import { IDataProvidersResolver } from '@epicuro-next/data-providers/providers-registry';
import { IDynamicBindableValue } from '@epicuro-next/models/platform/dynamic-elements/dynamic-elements';
import { isObservable, mergeMap, Observable, Subject, takeUntil } from 'rxjs';

export function resolveDynamicBindableValuesFromDataProvidersResolver(
  dataProvidersResolver: IDataProvidersResolver,
  componentRef: ComponentRef<unknown>,
  dynamicBindableValues: { [key: string]: IDynamicBindableValue },
  resultContainer: { [key: string]: unknown },
  componentInjector?: Injector,
): void {
  const entriesOfdynamicBindableValues = Object.entries(dynamicBindableValues);

  if (entriesOfdynamicBindableValues.length === 0) {
    return;
  }

  const isDestroyed$ = new Subject<void>();
  componentRef.onDestroy(() => {
    isDestroyed$.next();
    isDestroyed$.complete();
  });

  entriesOfdynamicBindableValues.forEach(([dataKey, value]) => {
    const { provider, property } = value;

    const dataProvider = dataProvidersResolver.resolve(
      provider,
      componentInjector,
    );

    let observable$: unknown;

    if (isObservable(property)) {
      observable$ = property.pipe(
        mergeMap((valueOfProperty) => {
          const nestedResultContainer: typeof resultContainer = {};

          resolveDynamicBindableValuesFromDataProvidersResolver(
            dataProvidersResolver,
            componentRef,
            { [dataKey]: { provider, property: valueOfProperty } },
            nestedResultContainer,
            componentInjector,
          );

          return nestedResultContainer[dataKey] as Observable<unknown>;
        }),
        takeUntil(isDestroyed$),
      );
    } else {
      observable$ = dataProvider.read(property).pipe(takeUntil(isDestroyed$));
    }

    resultContainer[dataKey] = observable$;
  });
}
